import { IdentificativoRichiestaDTO } from "./identificativo-richiesta-dto";

export class CreazioneBozzaResponse {
	id: IdentificativoRichiestaDTO;
}